import React, { Fragment, useEffect } from "react"
import "./layout.css"
import "../css/main.css"
import NavBar from "./NavBar"
import Footer from "./Footer"
import ReactGA from 'react-ga'
import { useLocation } from "react-router-dom";

const trackingId = "UA-169863041-1" // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId)

const Layout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
	ReactGA.pageview(location.pathname + location.search)
    }, [location.pathname, location.search])
    
    return (
	<Fragment>
	    <NavBar />
	    <main>{children}</main>
	    <Footer />
	</Fragment>
    )
}

export default Layout
